/**
 * Cookie utility functions
 */

/**
 * Get a cookie by name
 * @param {string} name - The name of the cookie to get
 * @returns {string|null} - The cookie value or null if not found
 */
export const getCookie = (name) => {
  const cookies = document.cookie.split(';');
  for (let i = 0; i < cookies.length; i++) {
    const cookie = cookies[i].trim();
    if (cookie.startsWith(`${name}=`)) {
      return cookie.substring(name.length + 1);
    }
  }
  return null;
};

/**
 * Set a cookie
 * @param {string} name - The name of the cookie
 * @param {string} value - The value of the cookie
 * @param {Object} options - Options for the cookie
 * @param {number} options.days - Number of days until the cookie expires
 * @param {boolean} options.secure - Whether the cookie should be secure
 * @param {boolean} options.httpOnly - Whether the cookie should be HTTP only
 * @param {string} options.path - The path for the cookie
 * @param {string} options.sameSite - The SameSite policy for the cookie
 * @param {string} options.domain - The domain for the cookie
 */
export const setCookie = (name, value, options = {}) => {
  const { days = 7, secure = true, path = '/', sameSite = 'strict' } = options;
  
  const expires = new Date();
  expires.setTime(expires.getTime() + days * 24 * 60 * 60 * 1000);
  
  let cookieString = `${name}=${value}; expires=${expires.toUTCString()}; path=${path}`;
  
  if (secure) {
    cookieString += '; secure';
  }
  
  if (sameSite) {
    cookieString += `; samesite=${sameSite}`;
  }
  
  if (options.domain) {
    cookieString += `; domain=${options.domain}`;
  }
  
  document.cookie = cookieString;
};

/**
 * Remove a cookie
 * @param {string} name - The name of the cookie to remove
 * @param {string} path - The path of the cookie
 * @param {string} domain - The domain of the cookie
 */
export const removeCookie = (name, path = '/', domain = '') => {
  const expireDate = 'Thu, 01 Jan 1970 00:00:01 GMT';
  document.cookie = `${name}=; expires=${expireDate}; path=${path}${domain ? `; domain=${domain}` : ''}`;
}; 